import React from "react";

function Pagination({ pagination, updateFilter }) {
  if (!pagination || pagination.totalPages <= 1) return null;

  return (
    <div className="col-md-6 text-end p-2" style={{ justifyItems: "right" }}>
      <nav aria-label="Page navigation" className="pagination-style-4">
        <ul className="pagination mb-0 flex-wrap">
          {/* Prev */}
          <li
            className={`page-item ${pagination.page === 1 ? "disabled" : ""}`}
          >
            <button
              className="page-link"
              disabled={pagination.page === 1}
              onClick={() => updateFilter("page", pagination.page - 1)}
            >
              Prev
            </button>
          </li>

          {/* First Page */}
          {pagination.totalPages > 1 && (
            <li
              className={`page-item ${pagination.page === 1 ? "active" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => updateFilter("page", 1)}
              >
                1
              </button>
            </li>
          )}

          {/* Dynamic Pages */}
          {(() => {
            const pages = [];
            const start = Math.max(2, pagination.page - 2);
            const end = Math.min(
              pagination.totalPages - 1,
              pagination.page + 2,
            );

            if (start > 2) {
              pages.push(
                <li key="dots-left" className="page-item disabled">
                  <span className="page-link">...</span>
                </li>,
              );
            }

            for (let i = start; i <= end; i++) {
              pages.push(
                <li
                  key={i}
                  className={`page-item ${
                    pagination.page === i ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => updateFilter("page", i)}
                  >
                    {i}
                  </button>
                </li>,
              );
            }

            if (end < pagination.totalPages - 1) {
              pages.push(
                <li key="dots-right" className="page-item disabled">
                  <span className="page-link">...</span>
                </li>,
              );
            }

            return pages;
          })()}

          {/* Last Page */}
          {pagination.totalPages > 1 && (
            <li
              className={`page-item ${
                pagination.page === pagination.totalPages ? "active" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => updateFilter("page", pagination.totalPages)}
              >
                {pagination.totalPages}
              </button>
            </li>
          )}

          {/* Next */}
          <li
            className={`page-item ${
              pagination.page === pagination.totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              disabled={pagination.page === pagination.totalPages}
              onClick={() => updateFilter("page", pagination.page + 1)}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Pagination;
